// src/Routes/router.jsx
import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "../Pages/AuthPages/Login/Login";
import PageNotFound from "../Exceptions/PageNotFound";
import RouteProtector from "./Layouts/IndexPageLayout";
import ForgotPassword from "../Pages/AuthPages/Forgot_Password/ForgotPassword";
import ResetPassword from "../Pages/AuthPages/Reset_Password/ResetPassword";
import Attendance from "../Pages/Attendance/Attendance";
import ChangePassword from "../Pages/Settings/ChangePassword";
import UpdateCredentials from "../Pages/Settings/UpdateCredentials";
import OtpVerify from "../Pages/AuthPages/OtpVerify/OtpVerify";
import OrganizationChangePage from "../Pages/Orgnaization/Organisation/OrganizationChangePage";
import MainAuth from "../Pages/AttendenceRecord/MainAuth";
// Routes
const router = createBrowserRouter([
  



  {
    path: "/otp-verify",
    element: <OtpVerify />,
  },

  {
    path: "/organization-toggle",
    element: (
      <RouteProtector>
        <OrganizationChangePage />
      </RouteProtector>
    ),
  },

  {
    path: "/",
    element: (
      <RouteProtector>
        <MainAuth />
      </RouteProtector>
    ),
  },





  {
    path: "/settings/change-password",
    element: (
      <RouteProtector>
        <ChangePassword />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/update-credentials",
    element: (
      <RouteProtector>
        <UpdateCredentials />
      </RouteProtector>
    ),
  },

  {
    path: "/attendance",
    element: (
      <RouteProtector>
        <Attendance />
      </RouteProtector>
    ),
  },

  {
    path: "/login",
    element: (
      <Login
        title={"Attendance Login"}
        appName={"Attendance"}
        description={
          "Use your HR ERP credentials to mark attendance. Same login works across HR, EMS, and PM."
        }
      />
    ),
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword title={"Forgot Password"} />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword title={"Reset Password"} />,
  },

  {
    path: "*",
    element: <PageNotFound />,
  },
]);

export default router;
